import { GRAYLOG_DEFINITION_ID } from '../constants'
import { useIntegrationList } from '../queries'

export const useCheckIntegrations = () => {
	const { data: integrations } = useIntegrationList()

	const hasIntegrations = integrations.length > 0
	const hasGraylog = integrations.some(
		({ connector }) => connector.definition_id === GRAYLOG_DEFINITION_ID,
	)

	return { hasIntegrations, hasGraylog }
}
